module.exports = __webpack_public_path__ + "img/home_header_2.4cda954d.png";